// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';

import './Item.scss';

interface ItemProps {
    children: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
    modeReverse?: boolean;
}

export const Item = ({
    children,
    onClick,
    disabled = false,
    className,
    modeReverse = false,
}: ItemProps): ReactElement => (
    <div
        className={classList('th-menu__item', className, { disabled, click: !!onClick, 'mode-reverse': modeReverse })}
        {...(!disabled ? { onClick } : {})}
    >
        {children}
    </div>
);
